import { render, staticRenderFns } from "./RegistrationLookupResultComponent.vue?vue&type=template&id=cf4b819c"
import script from "./RegistrationLookupResultComponent.vue?vue&type=script&lang=ts"
export * from "./RegistrationLookupResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports